import React from 'react';
import { withTranslation } from 'react-i18next';
import LoadingOverlay from 'react-loading-overlay';

export default withTranslation()(({ active }) => (
  <LoadingOverlay
    active={active}
    spinner
    styles={{
      wrapper: {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: 'fixed',
        zIndex: -1,
      },
      overlay: (base) => ({
        ...base,
        background: '#ffffff99',
      }),
      spinner: (base) => ({
        ...base,
        '& svg circle': {
          stroke: '#0db5ff !important',
        },
      }),
    }}
  />
));
